import React from 'react';
import dayjs from 'dayjs';
import { spotTrackingImageDefault } from 'Constants/Constants';
import OrderStatusTracking from 'components/Spot/Spot/OrderStatusTracking';
import { SpotTrackingTimeline } from '../SpotTrackingTimeline';
import { useSelector } from 'react-redux';
import { Divider, VertTypography } from '@vertem-core/vertice-ds';

export const SpotContainerModal = ({ productData, spot, parentOrderId = '' }) => {
  const { spotDataTracking } = useSelector((state) => state.SpotGroups);
  const { orders } = spot || {};
  const orderNumber = orders?.find(({ parentOrderId }) => parentOrderId)?.parentOrderId;

  const {
    trackingCode,
    urlTracking,
    trackingHistories,
    createdAt,
    supplierName,
    trackingStatusCodeId,
    trackingStatusCode,
  } = spotDataTracking || {};
  const isShipping = false;

  return (
    <>
      <VertTypography.Title level={3} className='modal-title-spot-tracking' strong>
        Resgate realizado em {dayjs(createdAt).format('DD/MM/YYYY')}
      </VertTypography.Title>
      <Divider />

      <div className='container-modal-spot-tracking'>
        <span className='tracking-number-and-status'>
          <VertTypography.Paragraph className='order-number'>
            #Pedido {orderNumber || parentOrderId}
          </VertTypography.Paragraph>
          <Divider type='vertical' />

          <OrderStatusTracking
            trackingStatusCode={trackingStatusCodeId}
            trackingText={trackingStatusCode}
          />
        </span>

        <div className='tracking-infos'>
          <span className='tracking-spot-info'>
            <img className='item-image' alt='Nome do Item' src={spotTrackingImageDefault} />
          </span>
          <span className=' tracking-spot-info-details'>
            <VertTypography.Paragraph className='tracking-spot-info-title'>
              {productData?.name}
            </VertTypography.Paragraph>
            {supplierName && (
              <VertTypography.Paragraph className='item-vendor'>
                Fornecido e entregue por {supplierName}
              </VertTypography.Paragraph>
            )}

            {trackingCode && (
              <VertTypography.Paragraph className='item-code'>
                Código de rastreio:
                {urlTracking ? (
                  <a
                    href={
                      String(urlTracking).includes('https') ? urlTracking : `https://${urlTracking}`
                    }
                    target='_blank'
                    className='item-code-link'
                  >
                    {trackingCode.length > 20 ? `${trackingCode.slice(0, 20)}...` : trackingCode}
                  </a>
                ) : (
                  <span className='item-code-text'>
                    {trackingCode.length > 20 ? `${trackingCode.slice(0, 20)}...` : trackingCode}
                  </span>
                )}
              </VertTypography.Paragraph>
            )}
            <VertTypography.Paragraph
              className={`item-shipping-value ${!isShipping && 'visible-hidden-tracking'}`}
            >
              Frete: <span className='highlight'>Grátis</span>
            </VertTypography.Paragraph>
          </span>
        </div>

        <div className='tracking-details'>
          <VertTypography.Title className='tracking-details-title'>
            Detalhes do rastreio
          </VertTypography.Title>
          <div className='tracking-stepper-status'>
            <SpotTrackingTimeline
              trackingHistories={trackingHistories}
              currentTimelineStepper={trackingStatusCodeId}
            />
          </div>
        </div>
      </div>
    </>
  );
};
